import "assets/styles/components/_activity-pulse-dot.scss";

/** 새 활동이 있는 메뉴의 이동 경로를 알려주는 작고 접근성 있는 펄스 표시. */
export default function ActivityPulseDot({ label = "새로운 활동 있음" }) {
  return (
    <span className="activity-pulse-dot" role="status" aria-label={label} title={label}>
      <span className="activity-pulse-dot__ring" aria-hidden="true" />
    </span>
  );
}
